export function doArraysContainSameNumbers(first: number[], second: number[]): boolean {
	return first.length === second.length && first.every((value) => second.includes(value));
}
